// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__278Ws","content":"styles_content__1SGvx"};